import { useState, useEffect, useMemo } from "react";
import { commonAPI } from "../../../../services/CommonAPIService";
import { toast } from "react-toastify";

const FlatSelectorModal = ({ initialSelected = [], onBack, onContinue }) => {
  const [towers, setTowers] = useState([]);
  const [allFlats, setAllFlats] = useState([]);
  const [selectedTower, setSelectedTower] = useState(null);
  const [pickedFlats, setPickedFlats] = useState({}); 
  const [loading, setLoading] = useState(true);
  const [initialized, setInitialized] = useState(false);

  // Current flats for selected tower
  const currentFlats = useMemo(() => {
    if (!selectedTower) return [];
    return allFlats.filter((f) => f.towerId === selectedTower.towerId);
  }, [selectedTower, allFlats]);

  const currentSelections = useMemo(() => {
    if (!selectedTower) return new Set();
    return pickedFlats[selectedTower.towerId] || new Set();
  }, [pickedFlats, selectedTower]);

  // Fetch towers & all flats once
useEffect(() => {
  const loadData = async () => {
    setLoading(true);

    const auth = JSON.parse(localStorage.getItem("userData") || "{}");
    const buildingId = auth?.buildingId;

    try {
      // Fetch towers
      const towerRes = await commonAPI("Tower", undefined, { buildingId });

      if (towerRes?.success) {
        const towerList = towerRes.data || [];
        setTowers(towerList);
        if (towerList.length > 0) {
          setSelectedTower(towerList[0]);
        }
      } else {
        throw new Error(towerRes?.message || "Failed to load towers");
      }

      // Fetch flats
      const flatRes = await commonAPI("Flat", undefined, { buildingId });

      if (flatRes?.success) {
        setAllFlats(flatRes.data || []);
      } else {
        throw new Error(flatRes?.message || "Failed to load flats");
      }

    } catch (err) {
      console.error("LoadData Error:", err);

      const bodyError = {
        userId: auth?.userId || null,
        mobileNumber: auth?.mobileNumber || null,
        requestJSON: null,
        uri: "/api/Master/Tower-Flat",
        errorSource: "CuroNextPortal",
        errorNumber: "FLTSLCTR01",
        errorSummary: err?.message,
        errorDescription: JSON.stringify(err),
        fileClassName: "FlatSelectorModal.js",
        functionName: "loadData",
      };

      try {
        await commonAPI("ErrorLogMaster", bodyError);
      } catch (logErr) {
        console.error("Error while logging error:", logErr);
      }

      toast.error(err?.message || "Error loading data");
    } finally {
      setLoading(false);
    }
  };

  loadData();
}, []);
  useEffect(() => {
    if (allFlats.length === 0 || initialized) return;

    const initialMap = {};
    
    initialSelected.forEach((sel) => {
      const flat = allFlats.find((f) => f.flatId === sel.flatId);
      if (flat) {
        if (!initialMap[flat.towerId]) {
          initialMap[flat.towerId] = new Set();
        }
        initialMap[flat.towerId].add(flat.flatId);
      }
    });

    setPickedFlats(initialMap);
    setInitialized(true);
  }, [allFlats, initialSelected, initialized]);

  const toggleFlat = (flatId) => {
    if (!selectedTower) return;

    setPickedFlats((prev) => {
      const towerId = selectedTower.towerId;
      const currentSet = new Set(prev[towerId] || []);
      
      if (currentSet.has(flatId)) {
        currentSet.delete(flatId);
      } else {
        currentSet.add(flatId);
      }
      
      const newState = { ...prev };
      
      if (currentSet.size > 0) {
        newState[towerId] = currentSet;
      } else {
        delete newState[towerId]; 
      }
      
      return newState;
    });
  };

  const handleContinue = () => {
    const result = [];
    Object.entries(pickedFlats).forEach(([towerIdStr, flatIdSet]) => {
      const towerId = Number(towerIdStr);
      flatIdSet.forEach((flatId) => {
        const flat = allFlats.find((f) => f.flatId === flatId);
        if (flat) {
          const tower = towers.find((t) => t.towerId === flat.towerId);
          result.push({
            flatId: flat.flatId,
            flatName: flat.flatName || flat.flatNumber || `Flat ${flat.flatId}`,
            towerId: flat.towerId,
            towerName: tower?.towerName || "",
          });
        }
      });
    });

    onContinue(result);
  };

  // Count total selected flats
  const totalSelected = useMemo(() => {
    return Object.values(pickedFlats).reduce((sum, set) => sum + set.size, 0);
  }, [pickedFlats]);

  if (loading) {
    return (
      <div className="d-flex align-items-center justify-content-center" style={{ height: "100%", minHeight: "400px" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (towers.length === 0) {
    return (
      <div className="text-center py-5 text-muted">
        No towers found in this building.
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%",overflowY:"auto" }}>
     <div className="d-flex justify-content-center mb-3">
    <label className="form-label fw-bold mb-2">Select Flats</label>

  </div>


      {/* Tower Tabs – horizontal scrollable */}
<div
  id="towerScroll"
  className="tower-scroll"
  style={{
    display: "flex",
    overflowX: "auto",
    border: "1px solid #e0e0e0",
    borderRadius: 10,
    marginBottom: 16,
    background: "#fff",
  }}
>

        {towers.map((tower, idx) => {
          const isActive = selectedTower?.towerId === tower.towerId;
          const count = pickedFlats[tower.towerId]?.size || 0;

          return (
            <button
              key={tower.towerId}
              onClick={() => setSelectedTower(tower)}
              style={{
                flex: "0 0 auto",
                minWidth: 110,
                padding: "12px 20px",
                border: "none",
                borderRight: idx < towers.length - 1 ? "1px solid #e0e0e0" : "none",
                background: isActive ? "#1C80D2" : "#ffffff",
                color: isActive ? "#ffffff" : "#333333",
                fontWeight: isActive ? 700 : 500,
                cursor: "pointer",
                whiteSpace: "nowrap",
                transition: "all 0.2s ease",
                
              }}
            >
              {tower.towerName}
              {count > 0 && (
                <span
                  style={{
                    marginLeft: 8,
                    padding: "3px 7px",
                    borderRadius: 12,
                    background: isActive ? "#ffffff" : "#1C80D2",
                    color: isActive ? "#1C80D2" : "#ffffff",
                    fontSize: 12,
                    fontWeight: 700,
                  }}
                >
                  {count}
                </span>
              )}
            </button>
          );
        })}
      </div>

      {/* Flats Grid */}
          <div
            className="vertical-scroll"
            style={{
              flex: 1,
              overflowY: "auto",
              padding: "0 4px",
              maxHeight: "200px",  
            }}
          >

        {currentFlats.length === 0 ? (
          <div className="text-center py-5 text-muted">
            No flats found in this tower.
          </div>
        ) : (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(80px, 1fr))",
              gap: 10,
            }}
          >
            {currentFlats.map((flat) => {
              const isSelected = currentSelections.has(flat.flatId);

              return (
                <button
                  key={flat.flatId}
                  onClick={() => toggleFlat(flat.flatId)}
                  style={{
                    padding: "10px 6px",
                    borderRadius: 8,
                    border: isSelected ? "2px solid #1C80D2" : "1.5px solid #d0d0d0",
                    background: isSelected ? "#1C80D2" : "#f9f9f9",
                    color: isSelected ? "#ffffff" : "#333333",
                    fontWeight: isSelected ? 600 : 500,
                    fontSize: 14,
                    cursor: "pointer",
                    textAlign: "center",
                    minHeight: 48,
                    transition: "all 0.2s ease",
                  }}
                >
                  {flat.flatName || flat.flatNumber || flat.flatId}
                </button>
              );
            })}
          </div>
        )}
      </div>

      {/* Footer buttons */}
      <div className="d-flex gap-3 mt-4">
        <button
          onClick={onBack}
          style={{
            flex: 1,
            padding: 14,
            borderRadius: 30,
            border: "1.5px solid #1C80D2",
            background: "transparent",
            color: "#1C80D2",
            fontWeight: 600,
            fontSize: "15px",
            cursor: "pointer",
          }}
        >
          Back
        </button>

        <button
          onClick={handleContinue}
          disabled={totalSelected === 0}
          style={{
            flex: 1,
            padding: 14,
            borderRadius: 30,
            border: "none",
            background: totalSelected > 0 ? "#1C80D2" : "#a0c4ff",
            color: "#ffffff",
            fontWeight: 600,
            fontSize: "15px",
            cursor: totalSelected > 0 ? "pointer" : "not-allowed",
          }}
        >
          Continue ({totalSelected})
        </button>
      </div>
      
    </div>
  );
};

export default FlatSelectorModal;